import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import HorizontalForm from './components/ViewInventoryOwner';
import Table from '../../Tables/DataTable/components/DataTable';
/*import VerticalForm from './components/masterForm';*/
/*import showResults from '../Show';*/

const ViewInventoryOwner = ({ t }) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Inventory Owner - View</h3>
      </Col>
    </Row>
   
    <Row>
      <HorizontalForm />
    </Row>

  </Container>
);

ViewInventoryOwner.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ViewInventoryOwner);
